import { FormatOptions } from '@common/utility/currency';

export const CURRENCY_OPTIONS: FormatOptions = {
  currencySign: 'accounting',
  maximumFractionDigits: 4,
  minimumFractionDigits: 2,
};
